import React from 'react';

const LoadingRound: React.FC = () => (
	<div>
		<p>Loading game...</p>
	</div>
);

export default LoadingRound;
